<template>
  <a-row id="secondStep" style="width: 100%">
    <editAllStep
      v-if="rightVisible == 5"
      :info="info"
      :COMPANY_LIST="COMPANY_LIST"
      :MY_COMPANY_LIST="MY_COMPANY_LIST"
      :USER_LIST="USER_LIST"
      :VAT_LIST="VAT_LIST"
      :DEAL="DEALEDIT"
      :user_setup="user_setup"
      :sale_record="sale_record"
      ref="newForm"
      @checkPositionFunc="checkPositionFunc"
      @changeSpinning="changeSpinning"
      @onClose="onClose"
      @goSteps="goSteps"
      @onback="handlerBack"
    />

    <a-form-model
      id="salesForm4"
      ref="form"
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="width: 100%"
    >
      <div v-if="rightVisible == 2 || rightVisible == 1">
        <a-row :gutter="16" style="margin-bottom: 10px; font-weight: 700">
          <a-col :span="12">
            <div>
              {{
                sale_record.invoiceAutoNumber + " " + sale_record.invoiceTitle
              }}
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Spółka')" prop="company">
              <div>
                <a
                  :href="`https://${domain}/crm/company/details/${myCompany.ID}/`"
                  target="_blank"
                  >{{ myCompany.TITLE }}</a
                >
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :label="$t('Data wystawienia')"
              prop="billingDate"
            >
              <div>{{ sale_record.billingDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Konto bankowe')" prop="bankAccaunt">
              <div>{{ sale_record.bankAccount }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data sprzedaży')" prop="saleDate">
              <div>{{ sale_record.saleDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Kontrahent')" prop="contractor">
              <div>
                <a
                  :href="`https://${domain}/crm/company/details/${contractor.ID}/`"
                  target="_blank"
                  >{{ contractor.TITLE }}</a
                >
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data usługi')">
              <div>{{ sale_record.serviceDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Opiekun')">
              <div>{{ this.user.NAME + " " + this.user.LAST_NAME }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Termin płatności')" prop="dueDate">
              <div>{{ sale_record.dueDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Projekt')">
              <div>
                <a
                  :href="`https://${domain}/crm/deal/details/${DEAL.ID}/`"
                  target="_blank"
                  >{{ this.DEALPROJECT.TITLE }}</a
                >
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Przypomnienie')" prop="reminder">
              <div>{{ sale_record.reminder }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Rodzaj')" prop="invoiceType">
              <div>{{ $t(sale_record.invoiceType) }}</div>
            </a-form-model-item>
          </a-col>
          <a-col
            :span="12"
            v-if="
              this.sale_record.invoiceCorrection != '' ||
              this.sale_record.correctionBack != ''
            "
          >
            <a-form-model-item label="Korekta">
              <div>
                {{ titleCorrectionInv }}
                <a-button type="link" @click="showDrawer" icon="eye" />
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Payment')" prop="paymentType">
              <div>{{ $t(sale_record.paymentType) }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Description')">
              <div>{{ sale_record.description }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Waluta, kurs')" prop="currency">
              <a-row :gutter="16">
                <a-col :span="12">
                  <div>{{ sale_record.currency }}</div>
                </a-col>
                <a-col :span="12">
                  <div>{{ sale_record.course }}</div>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Status')">
              <div>{{ $t(sale_record.status) }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Date of booking')">
              <div>{{ sale_record.publicationDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Notatka')">
              <div>{{ sale_record.comment }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Język')">
              <div>{{ $t(sale_record.language) }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-table
            :columns="columns"
            tableLayout="auto"
            :scroll="{ x: true }"
            :data-source="dataSource"
            :pagination="{ hideOnSinglePage: true }"
            bordered
          ></a-table>
        </a-row>

        <a-row :gutter="16" style="margin-top: 10px">
          <a-col :span="2">
            <a-button
              type="primary"
              icon="history"
              @click="kwotaHistoryVisible = !kwotaHistoryVisible"
            />
          </a-col>
        </a-row>
        <!--<a-row :gutter="16" style="margin-top: 10px">
          <a-col :span="2">
            <a-button
              type="primary"
              icon="history"
              @click="kwotaHistoryVisible = !kwotaHistoryVisible"
            />
          </a-col>
          <a-col :span="7"></a-col>
          <a-col :span="5">
            <a-form-model-item :label="$t('Netto')" prop="netto">
              <a-input
                v-model="sale_record.netto"
                disabled
                style="background-color: #e4edf9f2"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item :label="$t('Vat')" prop="vat">
              <a-input
                v-model="sale_record.vat"
                disabled
                style="background-color: #e4edf9f2"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item :label="$t('Brutto')" prop="brutto">
              <a-input
                v-model="sale_record.totalAmout"
                disabled
                style="background-color: #e4edf9f2"
              />
            </a-form-model-item>
          </a-col>
        </a-row>-->

        <a-row :gutter="16">
          <a-col :span="13">
            <a-timeline
              style="padding: 15px 0 0 25px"
              v-show="kwotaHistoryVisible"
            >
              <a-timeline-item
                v-for="(item, index) in kwotaVals.history"
                :key="index"
              >
                <a-row type="flex" justify="space-around" align="middle">
                  <a-col :span="4">
                    {{ item.date }}
                  </a-col>
                  <a-col :span="4">
                    {{ item.payment }}
                  </a-col>
                  <a-col :span="4">
                    {{ getUser(item.user) }}
                  </a-col>
                  <a-col :span="4">
                    <a-button
                      type="link"
                      icon="delete"
                      style="color: #ff4d4f"
                      v-if="profile.ADMIN || profile.ID == item.user"
                      @click="() => handlerKwotaDelete(index)"
                    />
                  </a-col>
                </a-row>
              </a-timeline-item>
            </a-timeline>
          </a-col>
        </a-row>

        <a-row
          :gutter="16"
          type="flex"
          justify="center"
          style="margin-top: 10px"
        >
          <a-statistic
            :title="$t('Netto')"
            :value="sale_record.netto"
            style="margin-right: 25px"
            :precision="2"
          />
          <a-divider type="vertical" style="height: 5em" />
          <a-statistic
            :title="$t('Vat')"
            :value="sale_record.vat"
            style="margin-right: 25px; margin-left: 25px"
            :precision="2"
          />
          <a-divider type="vertical" style="height: 5em" />
          <a-statistic
            :title="$t('Brutto')"
            :value="sale_record.totalAmout"
            style="margin-left: 25px"
            :precision="2"
          />
        </a-row>
      </div>
      <div v-if="rightVisible == 8">
        <a-row :gutter="16" style="margin-top: 20px">
          <a-col :span="10">
            <a-form-model-item :label="$t('Notatka')">
              <a-input v-model="form.comment" type="textarea" />
            </a-form-model-item>
            <a-form-model-item :label="$t('Data księgowania')">
              <a-date-picker
                v-model="form.publicationDate"
                type="date"
                :locale="locale"
                style="width: 100%"
              />
            </a-form-model-item>
            <a-form-model-item :label="$t('Kwota')">
              <a-input-number
                v-model="form.amount"
                @change="(e) => changeTotalAmout(e)"
              />
              <a-button
                type="primary"
                icon="plus"
                :disabled="!form.publicationDate || rightAccess == 0"
                style="margin-left: 10px"
                @click="() => handlerKwotaAdd()"
              />
            </a-form-model-item>
            <a-row type="flex" justify="space-between" style="margin-top: 10px">
              <a-statistic
                :title="$t('Pozostało do zapłaty')"
                :value="form.amountPaid"
                style="margin-right: 10px"
                :precision="2"
              />
              <a-button
                type="primary"
                icon="history"
                @click="kwotaHistoryVisible = !kwotaHistoryVisible"
              />
            </a-row>
            <div>
              <a-timeline
                style="padding: 15px 0 0 25px"
                v-show="kwotaHistoryVisible"
              >
                <a-timeline-item
                  v-for="(item, index) in kwotaVals.history"
                  :key="index"
                >
                  <a-row type="flex" justify="space-around" align="middle">
                    <a-col :span="4">
                      {{ item.date }}
                    </a-col>
                    <a-col :span="4">
                      {{ item.payment }}
                    </a-col>
                    <a-col :span="4">
                      {{ getUser(item.user) }}
                    </a-col>
                    <a-col :span="4">
                      <a-button
                        type="link"
                        icon="delete"
                        style="color: #ff4d4f"
                        v-if="profile.ADMIN || profile.ID == item.user"
                        @click="() => handlerKwotaDelete(index)"
                      />
                    </a-col>
                  </a-row>
                </a-timeline-item>
              </a-timeline>
            </div>
          </a-col>
          <a-col :span="6">
            <a-row type="flex" justify="center">
              <a-progress
                v-if="this.percent <= 100"
                type="circle"
                :percent="this.percent"
              />
              <a-progress
                v-if="this.percent > 100"
                type="circle"
                :percent="this.percent"
                status="exception"
              />
            </a-row>
          </a-col>
          <a-col :span="8">
            <a-row type="flex" justify="space-between">
              <a-statistic
                :title="$t('Rodzaj')"
                :value="sale_record.invoiceType"
              />
              <a-statistic
                :title="$t('Waluta')"
                :value="sale_record.currency"
              />
            </a-row>
            <!-- <a-row type="flex" justify="space-between" style="margin-top: 10px">
              <a-statistic
                :title="$t('Netto')"
                :value="sale_record.netto"
                :precision="2"
              />
              <a-divider type="vertical" style="height: 5em" />
              <a-statistic
                :title="$t('Vat')"
                :value="sale_record.vat"
                :precision="2"
              />
              <a-divider type="vertical" style="height: 5em" />
              <a-statistic
                :title="$t('Brutto')"
                :value="sale_record.totalAmout"
                :precision="2"
              />
            </a-row>-->
            <a-row
              :gutter="16"
              type="flex"
              justify="center"
              style="margin-top: 10px"
            >
              <a-statistic
                :title="$t('Netto')"
                :value="sale_record.netto"
                style="margin-right: 25px"
                :precision="2"
              />
              <a-divider type="vertical" style="height: 5em" />
              <a-statistic
                :title="$t('Vat')"
                :value="sale_record.vat"
                style="margin-right: 25px; margin-left: 25px"
                :precision="2"
              />
              <a-divider type="vertical" style="height: 5em" />
              <a-statistic
                :title="$t('Brutto')"
                :value="sale_record.totalAmout"
                style="margin-left: 25px"
                :precision="2"
              />
            </a-row>
          </a-col>
        </a-row>
      </div>
    </a-form-model>

    <a-drawer
      :title="correctDATA.invoiceTitle"
      placement="right"
      :visible="visible"
      :width="900"
      :after-visible-change="afterVisibleChange"
      @close="onCloseDrawer"
    >
      <a-form
        id="my_form_styl"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="width: 100%"
      >
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Spółka')" prop="company">
              <div>
                <a
                  :href="`https://${domain}/crm/company/details/${myCompanyCorrection.ID}/`"
                  target="_blank"
                  >{{ myCompanyCorrection.TITLE }}</a
                >
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :label="$t('Data wystawienia')"
              prop="billingDate"
            >
              <div>{{ correctDATA.billingDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Konto bankowe')" prop="bankAccaunt">
              <div>{{ correctDATA.bankAccount }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data sprzedaży')" prop="saleDate">
              <div>{{ correctDATA.saleDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Kontrahent')" prop="contractor">
              <div>
                <a
                  :href="`https://${domain}/crm/company/details/${contractorCorrection.ID}/`"
                  target="_blank"
                  >{{ contractorCorrection.TITLE }}</a
                >
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data usługi')">
              <div>{{ correctDATA.serviceDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Opiekun')">
              <div>
                {{
                  this.userCorrection.NAME + " " + this.userCorrection.LAST_NAME
                }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Termin płatności')" prop="dueDate">
              <div>{{ correctDATA.dueDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Projekt')">
              <div>
                <a
                  :href="`https://${domain}/crm/deal/details/${DEALcorrection.ID}/`"
                  target="_blank"
                  >{{ DEALcorrection.TITLE }}</a
                >
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Przypomnienie')" prop="reminder">
              <div>{{ correctDATA.reminder }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Rodzaj')" prop="invoiceType">
              <div>{{ correctDATA.invoiceType }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              v-if="
                this.correctDATA.invoiceCorrection != '' ||
                this.correctDATA.correctionBack != ''
              "
              label="Korekta"
            >
              <div>{{ this.sale_record.invoiceTitle }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Payment')" prop="paymentType">
              <div>{{ correctDATA.paymentType }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Opis')">
              <div>{{ correctDATA.description }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Waluta, kurs')" prop="currency">
              <a-row :gutter="16">
                <a-col :span="12">
                  <div>{{ correctDATA.currency }}</div>
                </a-col>
                <a-col :span="12">
                  <div>{{ this.currencyAmoutCorrection }}</div>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Język')">
              <div>{{ correctDATA.language }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-table
            :columns="columns"
            tableLayout="auto"
            :scroll="{ x: true }"
            :data-source="dataSourceCorrection"
            :pagination="{ hideOnSinglePage: true }"
            bordered
          ></a-table>
        </a-row>
      </a-form>
    </a-drawer>
  </a-row>
</template>
<script>
import moment from "moment";
import { requestStep } from "@/requestFunc";
import editAllStep from "@/components/sales_steps/editAllStep";

export default {
  components: {
    editAllStep,
  },
  props: [
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
    "VAT_LIST",
    "info",
    "profile",
    "DEAL",
    "sale_record",
    "user_setup",
  ],
  data() {
    return {
      moment,
      rightVisible: 0,
      currencyAmoutCorrection: "",
      myCompanyCorrection: "",
      contractorCorrection: "",
      dataSourceCorrection: [],
      userCorrection: [],
      DEALcorrection: "",
      myCompany: "",
      correctDATA: [],
      contractor: "",
      kwotaHistoryVisible: false,
      kwotaVals: {},
      DEALPROJECT: [],
      DEALEDIT: [],
      // DEAL: "",
      user: [],
      visible: false,
      titleCorrectionInv: "",
      currencyAmout: "",
      dataSource: [],
      cacheData: [],
      form: {
        itemID: this.sale_record.ID,
        publicationDate: "",
        amount: "",
        comment: "",
        paidPosition: [],
        params: [],
      },
      columns: [
        {
          title: this.$t("Nazwa produktu"),
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("Jednostka"),
          dataIndex: "units",
          scopedSlots: { customRender: "units" },
        },
        {
          title: this.$t("Rodzaj przychodu"),
          dataIndex: "type_arrival",
          scopedSlots: { customRender: "type_arrival" },
        },
        {
          title: this.$t("Stawka VAT"),
          dataIndex: "vat_rate",
          scopedSlots: { customRender: "vat_rate" },
        },
        {
          title: this.$t("Ilość"),
          dataIndex: "quantity",
          scopedSlots: { customRender: "quantity" },
        },
        {
          title: this.$t("Cena"),
          dataIndex: "unit_price",
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: this.$t("Netto"),
          dataIndex: "Netto",
        },
        {
          title: this.$t("Vat"),
          dataIndex: "Vat",
        },
        {
          title: this.$t("Brutto"),
          dataIndex: "Brutto",
        },
        {
          title: this.$t("Operacje"),
          dataIndex: "operation",
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "operation" },
        },
      ],
      editingKey: "",
      PRODUCT_LIST: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    getUser(id) {
      let user = this.sale_record.userInfo.find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : "";
    },
    afterVisibleChange() {},
    showDrawer() {
      this.visible = true;
    },
    onCloseDrawer() {
      this.visible = false;
    },
    onClose(element) {
      this.$emit("onClose", element);
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    /* saveValues() {
      let data = {
        run: "createSaleAndSaveStageOne",
      };

      for (let key in this.form) {
        if (
          key in this.sale_record &&
          this.form[key] != this.sale_record[key]
        ) {
          this.form[key] = {
            old: this.sale_record[key],
            new: this.form[key],
          };
        } else {
          delete this.form[key];
        }
      }

      Object.assign(data, this.form);

      return data;
    },*/
    saveValuesForm() {
      let data = {
        notUse: "createSaleAndSaveStageOne",
      };
      Object.assign(data, this.$refs.newForm.form);
      if (!Object.keys(this.sale_record)) {
        for (let key in data) {
          data[key] = {
            old: "",
            new: data[key],
          };
        }
      } else {
        for (let key in data) {
          if (key != "positions") {
            if (key in this.sale_record && data[key] != this.sale_record[key]) {
              data[key] = {
                old: this.sale_record[key],
                new: data[key],
              };
            } else {
              delete data[key];
            }
          }
        }
      }
      //Object.assign(data, this.$refs.newForm.form);
      this.$emit("checkPositionFunc", this.dataSource);
      return data;
    },
    saveValues() {
      let data = {
        params: "",
        run: "saveInvoiceStapThree",
        paidPosition: this.kwotaVals,
        itemID: this.sale_record.ID,
      };
      let newwData = {};

      Object.assign(newwData, this.form);
      for (let key in newwData) {
        if (key in this.sale_record && newwData[key] != this.sale_record[key]) {
          newwData[key] = {
            old: this.sale_record[key],
            new: newwData[key],
          };
        } else {
          delete newwData[key];
        }
      }
      delete newwData.run;
      delete newwData.paidPosition;
      delete newwData.itemID;
      Object.assign(data, newwData);

      return data;
    },
    handlerKwotaDelete(index) {
      this.kwotaVals.history.splice(index, 1);
      this.updateKwota();
      this.changeTotalAmout(0);
    },
    changeTotalAmout(event) {
      let total = event + this.sale_record.amountPaid * 1;

      let percentDO = (100 / (this.sale_record.netto / total)).toFixed(5);
      this.percent = Math.trunc(percentDO * 100) / 100;
      // this.form.amountPaid = +this.sale_record.netto - +this.sale_record.amountPaid;

      //  this.percent = (100 / (this.sale_record.netto / total)).toFixed(2);
    },
    handlerKwotaAdd() {
      let kwotaVal = +this.form.amount;
      if (!kwotaVal) return;
      let payment = kwotaVal.toFixed(2);
      let date = this.form.publicationDate
        ? moment(this.form.publicationDate).format("YYYY-MM-DD")
        : 0;

      if (date && payment) {
        this.kwotaVals.history.push({
          date,
          payment,
          user: this.profile.ID,
        });
      }
      this.kwotaHistoryVisible = true;
      this.updateKwota();
    },
    updateKwota() {
      this.form.amountPaid = this.kwotaVals.history.reduce(
        (accum, curr) => accum + +curr.payment,
        0
      );
      this.changeTotalAmout(this.form.amount);
      this.sale_record.amountPaid = this.form.amountPaid;
      this.form.amountPaid = +this.sale_record.netto - +this.form.amountPaid;
    },
    /*saveValuesForm() {
      let data = {
        notUse: "createSaleAndSaveStageOne",
      };
      if (this.sale_record == null || this.sale_record == "") {
        for (let key in this.$refs.newForm.form) {
          this.$refs.newForm.form[key] = {
            old: "",
            new: this.$refs.newForm.form[key],
          };
        }
      } else {
        for (let key in this.$refs.newForm.form) {
          if (key != "positions") {
            if (
              key in this.sale_record &&
              this.$refs.newForm.form[key] != this.sale_record[key]
            ) {
              this.$refs.newForm.form[key] = {
                old: this.sale_record[key],
                new: this.$refs.newForm.form[key],
              };
            } else {
              delete this.$refs.newForm.form[key];
            }
          }
        }
      }
      Object.assign(data, this.$refs.newForm.form);
      this.$emit("checkPositionFunc", this.dataSource);
      return data;
    },*/
    onSubmit(updateStatus) {
      this.$refs.form.validate((valid) => {
        this.changeSpinning();
        if (valid) {
          let format_moment = (date) =>
            date ? moment(date).format("YYYY-MM-DD") : "";
          this.form.publicationDate = format_moment(this.form.publicationDate);
          this.$refs.newForm.form.billingDate = format_moment(
            this.$refs.newForm.form.billingDate
          );
          this.$refs.newForm.form.dueDate = format_moment(
            this.$refs.newForm.form.dueDate
          );
          this.$refs.newForm.form.serviceDate = format_moment(
            this.$refs.newForm.form.serviceDate
          );
          this.$refs.newForm.form.saleDate = format_moment(
            this.$refs.newForm.form.saleDate
          );
          this.$refs.newForm.form.reminder = format_moment(
            this.$refs.newForm.form.reminder
          );
          var formsolo = this.saveValues();
          var refForm = this.saveValuesForm();
          this.form.paidPosition = this.kwotaVals;
          this.form["run"] = "saveInvoiceStapThree";
          this.form.itemID = this.sale_record.ID;
          this.form["updateStatus"] = updateStatus;
          formsolo.params = refForm;
          requestStep(formsolo, "./php/request.php")
            .done((data) => {
              let res = JSON.parse(data);

              if (res.status == "error") {
                this.$message.error(this.$t("Błąd aktualizacji"));
              } else {
                let prev = this.sale_record.status;
                this.sale_record.status = res.status;
                this.onClose({ prev, next: res.status });
                this.$message.success(
                  this.$t("Faktura została zaktualizowana!")
                );
              }
            })
            .always(() => {
              this.changeSpinning();
            });
        } else {
          this.changeSpinning();
          return false;
        }
      });
    },
  },
  mounted() {
    this.form.comment = this.sale_record.comment;
    this.DEALEDIT = this.DEAL;
    if (this.sale_record.amountPaid) {
      this.form.amountPaid =
        +this.sale_record.netto - +this.sale_record.amountPaid;
      this.changeTotalAmout(this.form.amount);
    }

    BX24.callMethod("user.admin", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        var isAdmin = result.data();

        BX24.callMethod("user.current", {}, (result) => {
          if (result.error()) console.error(result.error());
          else {
            var userCurrent = result.data();
            if (isAdmin == true) {
              this.rightVisible = 1;
            } else {
              if (this.user_setup.responsibleAll.includes(userCurrent.ID)) {
                this.rightVisible = 1;
              } else {
                this.rightVisible = 2;
              }
              if (this.rightVisible == 2) {
                this.DEALPROJECT =
                  this.DEAL.find((el) => el.ID == this.sale_record.project) ||
                  {};
              }
            }
          }
        });
      }
    });

    let auth = BX24.getAuth();
    this.domain = auth.domain;
    this.kwotaVals = Object.assign(
      {},
      this.kwotaVals,
      this.sale_record.paidPosition
    );
    if (this.sale_record.invoiceCorrection) {
      BX24.callMethod(
        "entity.item.get",
        {
          ENTITY: "invoices",
          FILTER: { ID: this.sale_record.invoiceCorrection },
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            this.titleCorrectionInv = result.data()[0]["PROPERTY_VALUES"][
              "invoiceTitle"
            ];
            this.correctDATA = result.data()[0]["PROPERTY_VALUES"];
            this.dataSourceCorrection = JSON.parse(this.correctDATA.positions);
            this.currencyAmoutCorrection = this.info.currency.filter((el) => {
              if (this.correctDATA.currency == el.CURRENCY) return el;
            })[0].AMOUNT;

            this.myCompanyCorrection = this.info.company.filter((el) => {
              if (this.correctDATA.company == el.ID) return el;
            })[0];

            this.contractorCorrection = this.info.company.filter((el) => {
              if (this.correctDATA.contractor == el.ID) return el;
            })[0];

            this.userCorrection = this.info.data_user.filter((el) => {
              if (this.correctDATA.responsible == el.ID) return el;
            })[0];

            BX24.callMethod(
              "crm.deal.get",
              { id: this.correctDATA.project },
              (result) => {
                if (result.error()) console.error(result.error());
                else {
                  this.DEALcorrection = result.data();
                }
              }
            );
          }
        }
      );
    } else if (this.sale_record.correctionBack) {
      BX24.callMethod(
        "entity.item.get",
        {
          ENTITY: "invoices",
          FILTER: { ID: this.sale_record.correctionBack },
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            this.titleCorrectionInv = result.data()[0]["PROPERTY_VALUES"][
              "invoiceTitle"
            ];
            this.correctDATA = result.data()[0]["PROPERTY_VALUES"];
            this.dataSourceCorrection = JSON.parse(this.correctDATA.positions);
            this.currencyAmoutCorrection = this.info.currency.filter((el) => {
              if (this.correctDATA.currency == el.CURRENCY) return el;
            })[0].AMOUNT;

            this.myCompanyCorrection = this.info.company.filter((el) => {
              if (this.correctDATA.company == el.ID) return el;
            })[0];

            this.contractorCorrection = this.info.company.filter((el) => {
              if (this.correctDATA.contractor == el.ID) return el;
            })[0];

            this.userCorrection = this.info.data_user.filter((el) => {
              if (this.correctDATA.responsible == el.ID) return el;
            })[0];

            BX24.callMethod(
              "crm.deal.get",
              { id: this.correctDATA.project },
              (result) => {
                if (result.error()) console.error(result.error());
                else {
                  this.DEALcorrection = result.data();
                }
              }
            );
          }
        }
      );
    }

    this.currencyAmout = this.info.currency.filter((el) => {
      if (this.sale_record.currency == el.CURRENCY) return el;
    })[0].AMOUNT;

    this.myCompany = this.sale_record.allCompany.filter((el) => {
      if (this.sale_record.company == el.ID) return el;
    })[0];

    this.contractor = this.sale_record.allCompany.filter((el) => {
      if (this.sale_record.contractor == el.ID) return el;
    })[0];

    this.user = this.sale_record.userInfo.filter((el) => {
      if (this.sale_record.responsible == el.ID) return el;
    })[0];

    this.dataSource = this.sale_record.positions;
    if (this.sale_record.project) {
      BX24.callMethod(
        "crm.deal.get",
        { id: this.sale_record.project },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            this.DEAL = result.data();
          }
        }
      );
    }

    BX24.callMethod("crm.product.list", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        this.PRODUCT_LIST = this.PRODUCT_LIST.concat(result.data());
        if (result.more()) result.next();
      }
    });

    BX24.fitWindow();
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.editable-add-btn {
  margin-top: 8px;
}
</style>